var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LinkWidget',{attrs:{"thumbnail-url":_vm.getValueObject.thumbnailUrl,"icon-url":_vm.getValueObject.icon,"title":_vm.getValueObject.title,"subline":_vm.getValueObject.subline,"url":_vm.getValueObject.resourceUrl,"truncate-length":20,"icon-size":25,"hide-default-icon":true,"underline-title":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }